import React from "react";
import { useStores } from "@ms/uno-controls/lib/local/hooks/useStores";
import { LazyLoopResponseSection } from "./LazyLoopResponseSection";
import { Store } from "@ms/uno-stores/lib/local/stores/Store";
// Constants
import { StoreEntityStatus } from "@ms/uno-constants/lib/local/StoreConstants";
// Action Creators
import { useActionCreators } from "@ms/uno-controls/lib/local/hooks/useActionCreators";
import { ActionCreator } from "@ms/uno-actioncreators/lib/local/actioncreators/ActionCreator";
/**
 * The LoopResponseSectionContainer component
 * @param props - The props for the component
 */ export const LoopResponseSectionContainer = ({ fetchAccessTokenCallback, taskId })=>{
    const [basicTaskStore, basicPermissionsStore, basicPlanStore] = useStores([
        Store.BasicTask,
        Store.BasicPermissions,
        Store.BasicPlan
    ]);
    const [basicTaskActionCreator] = useActionCreators([
        ActionCreator.BasicTask
    ]);
    const task = basicTaskStore?.getTask(taskId).data;
    if (!task) {
        return null;
    }
    const planId = task?.planId;
    const plan = planId ? basicPlanStore?.getPlan(planId).data : null;
    if (!plan) {
        return null;
    }
    const pageId = task.internalProperties.mars_planner_microsoft_LoopDetails?.pageId;
    if (pageId && basicTaskStore?.getLoopPageUrlForTask(taskId).status === StoreEntityStatus.Unfetched) {
        basicTaskActionCreator.fetchLoopPageUrlForTask(task);
    }
    const loopPageUrl = basicTaskStore?.getLoopPageUrlForTask(taskId).data ?? "";
    const isLoopURLLoading = basicTaskStore?.getLoopPageUrlForTask(taskId).status === StoreEntityStatus.Fetching;
    const planPermissions = basicPermissionsStore?.getPlanPermissions(plan);
    if (!isLoopURLLoading && !(loopPageUrl && (planPermissions?.canUseAgents || planPermissions?.canRenderLoopPage))) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(LazyLoopResponseSection, {
        fetchAccessTokenCallback: fetchAccessTokenCallback,
        loopPageUrl: loopPageUrl,
        taskId: taskId,
        isLoopURLLoading: isLoopURLLoading
    });
};
